import Api from '../../../../shared/Api';
import { IDelivery, InternalMessageResponse } from './Entities';

class PlanOrdersApi {
    static getAdminPlanOrder(planOrderId: number): Promise<any> {
        return new Api().get('/views/planorder/' + planOrderId + '/admin');
    }

    static getPlanOrder(planOrderId: number): Promise<any> {
        return new Api().get('/views/planorder/' + planOrderId);
    }

    static updatePlanOrderStoreySort(planOrderId: number, storey: any): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/storey/sort`, storey);
    }

    static sendPlanOrder(planOrderId: number, planOrder: any): any {
        return new Api().put(`/views/planorder/${planOrderId}`, planOrder);
    }

    static savePlanOrder(planOrderId: number, planOrder: any): Promise<any> {
        return new Api().post(`/views/planorder/${planOrderId}/save`, planOrder);
    }

    static deleteStorey(planOrderId: number, storeyId: number): Promise<any> {
        return new Api().delete(`/views/planorder/${planOrderId}/storeys/${storeyId}`);
    }

    static updateStorey(planOrderId: number, planOrderStoreyId: number, data: any): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/storey/${planOrderStoreyId}`, data);
    }

    static updatePlanFirm(planOrderId: number, planFirmId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/planfirm`, {
            planFirmId: planFirmId
        });
    }

    static updatePlanEditor(planOrderId: number, planEditorId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/planeditor`, {
            planEditorId: planEditorId
        });
    }

    static removePlanOrderRow(planOrderId: number, orderRowId: number): Promise<any> {
        return new Api().delete(`/views/planorder/${planOrderId}/orderrow/${orderRowId}`);
    }

    static addOrderRow(planOrderId: number, productId: number): Promise<any> {
        return new Api().post(`/views/planorder/${planOrderId}/orderrow`, {
            productId: productId
        });
    }

    static returnToBroker(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/return/broker`);
    }

    static sendToPlanFirm(planOrderId: number, data): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/sendtoplanfirm`, data);
    }

    static deliverPlanOrder(planOrderId: number, data: IDelivery): Promise<any> {
        return new Api().post(`/views/planorder/${planOrderId}/deliver`, data);
    }

    static returnSketchUpPlanOrder(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/return/sketchup`);
    }

    static returnRoomSketcherPlanOrder(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/return/roomsketcher`);
    }

    static returnPlanOrder(planOrderId: number, customerReturnedMessage: string): Promise<any> {
        return new Api().post(`/views/planorder/${planOrderId}/return`, {
            customerReturnedMessage: customerReturnedMessage
        });
    }

    static downloadFiles(planOrderId: number, isAgent: boolean = false): Promise<any> {
        if (isAgent) {
            return new Api().downloadFile(`/views/planorder/${planOrderId}/agent/download`);
        }

        return new Api().downloadFile(`/views/planorder/${planOrderId}/download`);
    }

    static emailFiles(planOrderId: number): Promise<any> {
        return new Api().post(`/views/planorder/${planOrderId}/emailfiles`, {});
    }

    static approvePlanOrder(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/approve`);
    }

    static generateFiles(planOrderId: number): Promise<any> {
        return new Api().post(`/views/planorder/${planOrderId}/generate`, {});
    }

    static deletePlanOrderExternalFile(planOrderId: number, fileInfoId: number): Promise<any> {
        return new Api().delete(`/views/planorder/${planOrderId}/file/${fileInfoId}`);
    }

    static deletePlanOrderStoreyExternalFile(
        planOrderId: number,
        planOrderStoreyId: number,
        fileInfoId: number
    ): Promise<any> {
        return new Api().delete(
            `/views/planorder/${planOrderId}/file/${fileInfoId}/storey/${planOrderStoreyId}`
        );
    }

    static createStorey(planorderId: number, data: any): Promise<any> {
        return new Api().postFiles(`/views/planorder/${planorderId}/storey`, data);
    }

    static updateStartDate(planorderId: number, date: any): Promise<any> {
        return new Api().put(`/views/planorder/${planorderId}/startdate`, {
            date: date
        });
    }

    static toggleTemplateGeneration(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/toggletemplategeneration`);
    }

    static resetDelivery(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/resetdelivery`);
    }

    static stopDelivery(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/stopdelivery`);
    }

    static adminGrab(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/admin-grab`);
    }

    static createEmptyStorey(planOrderId: number): Promise<any> {
        return new Api().post(`/views/planorder/${planOrderId}/storey/empty`, {});
    }

    static hideDeliveryFailure(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/hide-delivery-failure`);
    }

    static setSketchupStatus(planOrderId: number, newStatus: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/sketchup/status/${newStatus}`);
    }

    static setRoomsketcherStatus(planOrderId: number, newStatus: number): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/roomsketcher/status/${newStatus}`);
    }

    static email(planOrderId: number) {
        return new Api().post(`/views/planorder/${planOrderId}/email`, {});
    }

    static deleteDeliveryFile(reference: string) {
        return new Api().delete(`/views/planorder/deliveryfile/${reference}`);
    }

    static inActivateExternalFile(externalFileId: number) {
        return new Api().delete(`/views/planorder/external-file/${externalFileId}`);
    }

    static resetScheduledDelivery(planOrderId: number) {
        return new Api().put(`/views/planorder/${planOrderId}/reset-scheduled-delivery`);
    }

    static resetPlanOrderArchiveState(planOrderId: number) {
        return new Api().put(`/views/planorder/${planOrderId}/reset-planorder-archive-state`);
    }

    static returnCubiCasaOrder(planOrderId: number) {
        return new Api().put(`/views/planorder/${planOrderId}/return-cubi-casa-order`);
    }

    static deleteCubiCasaOrder(planOrderId: number) {
        return new Api().delete(`/views/planorder/${planOrderId}/delete-cubi-casa-order`);
    }
    static connectCubiCasaOrder(planOrderId: number, cubiCasaOrderId: string): Promise<any> {
        return new Api().put(`/views/planorder/${planOrderId}/connect/${cubiCasaOrderId}`)
    }
    static manualSyncCubiCasaOrder(planOrderId:number, cubiCasaOrderId: string): Promise<any> {
        return new Api().post(`/views/planorder/manual-sync/${planOrderId}/${cubiCasaOrderId}`)
    }

    static getInternalNotes(planOrderId: number): Promise<InternalMessageResponse> {
        return new Api().get(`/views/planorder/${planOrderId}/internal-message`);
    }

    static saveInternalNotes(planOrderId: number, internalNotes: string): Promise<void> {
        return new Api().put(`/views/planorder/${planOrderId}/update-internal-message`, {
            internalMessage: internalNotes
        });
    }
}

export default PlanOrdersApi;
